(function () {
    function isMobile() {
        return window.matchMedia('(max-width: 749px)').matches;
    }

    function isHomePage() {
        return (
            document.body.classList.contains('template-index') ||
            window.location.pathname === '/' ||
            window.location.pathname === ''
        );
    }

    function isInsideInitialHomeScreen() {
        var homeSearch = document.querySelector('.dunaih-hero__mobile-search');

        if (!homeSearch) {
            return window.scrollY < 160;
        }

        var rect = homeSearch.getBoundingClientRect();

        return rect.bottom > 0;
    }

    function getSearchUrl() {
        if (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) {
            return window.Shopify.routes.root + 'search';
        }

        return '/search';
    }

    function closeNativeSearch(summary) {
        var details = summary.closest('details');

        if (details) {
            details.removeAttribute('open');
        }
    }

    function handleHeaderSearch(event) {
        var summary = event.target.closest('.header__search summary.header__icon--search');

        if (!summary) return;
        if (!isMobile()) return;

        event.preventDefault();
        event.stopPropagation();
        event.stopImmediatePropagation();

        closeNativeSearch(summary);

        if (isHomePage() && isInsideInitialHomeScreen()) {
            return;
        }

        window.location.href = getSearchUrl();
    }

    document.addEventListener('click', handleHeaderSearch, true);
})();